import { Link, Button } from '@one-thd/sui-atomic-components';
import React from 'react';
import { OOS_RECOVERY_OPTIONS, FLOW_TYPES, } from '../../../constants/out-of-stock';
import { useOrderContext } from '../../../hooks/useContexts';
import { isBopisOutOfStockRecoverable } from './FulfillmentStatus';
var OOS_RECOVERY_OPTION_KEYS = Object.keys(OOS_RECOVERY_OPTIONS);
export var getFlowTypeValue = function (currentDrawer, currentFlow) {
    if (OOS_RECOVERY_OPTION_KEYS.includes(currentDrawer)) {
        return FLOW_TYPES.BOPIS_OOS_RECOVERY;
    }
    return currentFlow;
};
export var ZipCodeNotEligibleMessage = function (changeForm, fulfillmentGroup) {
    var setCurrentDrawer = useOrderContext().setCurrentDrawer;
    var isBopisOutOfStock = isBopisOutOfStockRecoverable(fulfillmentGroup);
    var baseMessage = (React.createElement(React.Fragment, null, "Delivery isn\u2019t available to your ZIP Code. You can enter a different ZIP Code"));
    var pickupMessage = isBopisOutOfStock ? (React.createElement(React.Fragment, null,
        ' or ',
        changeForm ? (React.createElement(Link, { onClick: function () {
                return setCurrentDrawer(OOS_RECOVERY_OPTIONS.STORE_PICKUP_OPTION);
            } }, "pick up your items at a different store.")) : ('pick up your items at a different store.'))) : ('.');
    return (React.createElement(React.Fragment, null,
        baseMessage,
        pickupMessage));
};
export var PickUpAtDifferentStoreButton = function () {
    var setCurrentDrawer = useOrderContext().setCurrentDrawer;
    var handlePickUpAtDifferentStore = function () {
        setCurrentDrawer(OOS_RECOVERY_OPTIONS.STORE_PICKUP_OPTION);
    };
    return (React.createElement("div", null,
        React.createElement(Button, { variant: "tertiary", fullWidth: true, onClick: handlePickUpAtDifferentStore }, "Pick Up at a Different Store")));
};
